<app-modal class="equipment-create-modal" [isLoading]="isLoading">
    <ng-container modal-header>
        <h5 class="modal-title" *ngIf="!isEditMode; else editTitle">{{
                'admin.equipment.create-modal.title' |
                    translate
            }}</h5>
        <ng-template #editTitle>
            <h5 class="modal-title">{{ 'admin.equipment.update-modal.title' | translate }}</h5>
        </ng-template>
    </ng-container>
    <div class="body" modal-body>
        <form class="picklist-form" [formGroup]="equipmentForm">
            <div class="form-group row">
                <div class="col s6">
                    <app-input formControlName="name"
                               [formControl]="equipmentForm.controls['name']"
                               [showErrors]="showValidations"
                               placeholder="{{'admin.equipment.create-modal.name-input.placeholder' | translate }}"
                               label="{{'admin.equipment.create-modal.name-input.label' | translate}}">
                    </app-input>
                </div>
                <div class="col s6">
                    <app-dropdown-autocomplete formControlName="lineId"
                                               [formControl]="equipmentForm.controls.lineId"
                                               name="lineId"
                                               [showErrors]="showValidations"
                                               [items]="lines"
                                               valueField="id"
                                               displayField="name"
                                               [label]="'admin.equipment.create-modal.line-input.label' | translate"
                                               [emptyText]="'admin.equipment.create-modal.line-input.placeholder' | translate"
                                               (selectItem)="onEquipmentChange($event)">
                    </app-dropdown-autocomplete>
                </div>
            </div>
            <div class="row">
                <div class="col s6">
                    <app-textarea formControlName="description"
                               [formControl]="equipmentForm.controls['description']"
                               [showErrors]="showValidations"
                               placeholder="{{'admin.equipment.create-modal.description-input.placeholder' | translate }}"
                               label="{{'admin.equipment.create-modal.description-input.label' | translate}}">
                    </app-textarea>
                </div>
                <div class="col s6">
                    <app-input formControlName="MESId"
                               [formControl]="equipmentForm.controls['MESId']"
                               [showErrors]="showValidations"
                               placeholder="{{'admin.equipment.create-modal.mes-id-input.placeholder' | translate }}"
                               label="{{'admin.equipment.create-modal.mes-id-input.label' | translate}}">
                    </app-input>
                </div>
            </div>
            <div class="row process-row">
                <div class="col s12">
                    <app-picklist
                        [source]="processTypes"
                        [(target)]="equipmentForm.value.processTypes"
                        sourceHeader="{{'admin.equipment.create-modal.process-types-input.leftHeader' | translate}}"
                        targetHeader="{{'admin.equipment.create-modal.process-types-input.rightHeader' | translate}}"
                        infoLabel="{{'admin.equipment.create-modal.alert.message' | translate}}"></app-picklist>
                </div>
            </div>
        </form>
    </div>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    [disabled]="isLoading"
                    (click)="modal.close()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>
        <div class="mutators">
            <app-button *ngIf="!isEditMode && shouldRenderModifiers()"
                        type="primary"
                        [disabled]="isLoading"
                        (click)="createEquipment()">
                {{ 'admin.equipment.create-modal.button.create'| translate }}
            </app-button>
            <app-button *ngIf="isEditMode && shouldRenderModifiers()"
                        type="warning"
                        [disabled]="isLoading"
                        (click)="updateEquipment()">
                {{ 'admin.equipment.create-modal.button.update'| translate }}
            </app-button>
            <app-button
                type="danger"
                *ngIf="isEditMode && shouldRenderModifiers()"
                [class.disabled]="isEquipmentInUse()"
                [disabled]="isLoading"
                (click)="deleteEquipment()">
                {{ 'admin.equipment.create-modal.button.delete' | translate }}
            </app-button>
        </div>
    </div>
</app-modal>
